export function isTouchable() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}
